import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import ManageShiftExchangeSmartview from 'pages/app/shifts/exchange/partials/smartviews/ManageShiftExchangeSmartview'
import ShiftExchangeEntryHeader from './ShiftExchangeEntryHeader'

export default function ShiftExchangeEntry () {
  const id = useValue('id')

  return (
    <MountSmartviewOnClick smartview={<ManageShiftExchangeSmartview id={id} />} replace={false} keepTreeOnPush>
      <ShiftExchangeEntryHeader />
    </MountSmartviewOnClick>
  )
}
